export const LEGAL_TYPES = {
  PRIVATE: 'PRIVATE',
  BUSINESS: 'BUSINESS',
} as const;

export type LegalType = (typeof LEGAL_TYPES)[keyof typeof LEGAL_TYPES];

export const currencyOptions = [
  { value: 'AUD', label: 'AUD — Australian Dollar' },
  { value: 'BRL', label: 'BRL — Brazilian Real' },
  { value: 'CAD', label: 'CAD — Canadian Dollar' },
  { value: 'CHF', label: 'CHF — Swiss Franc' },
  { value: 'CNY', label: 'CNY — Chinese Yuan' },
  { value: 'CZK', label: 'CZK — Czech Koruna' },
  { value: 'DKK', label: 'DKK — Danish Krone' },
  { value: 'EUR', label: 'EUR — Euro' },
  { value: 'GBP', label: 'GBP — British Pound' },
  { value: 'HKD', label: 'HKD — Hong Kong Dollar' },
  { value: 'HUF', label: 'HUF — Hungarian Forint' },
  { value: 'ILS', label: 'ILS — Israeli New Shekel' },
  { value: 'INR', label: 'INR — Indian Rupee' },
  { value: 'JPY', label: 'JPY — Japanese Yen' },
  { value: 'KRW', label: 'KRW — South Korean Won' },
  { value: 'MXN', label: 'MXN — Mexican Peso' },
  { value: 'NOK', label: 'NOK — Norwegian Krone' },
  { value: 'NZD', label: 'NZD — New Zealand Dollar' },
  { value: 'PKR', label: 'PKR — Pakistani Rupee' },
  { value: 'PLN', label: 'PLN — Polish Złoty' },
  { value: 'SEK', label: 'SEK — Swedish Krona' },
  { value: 'SGD', label: 'SGD — Singapore Dollar' },
  { value: 'THB', label: 'THB — Thai Baht' },
  { value: 'TRY', label: 'TRY — Turkish Lira' },
  { value: 'USD', label: 'USD — US Dollar' },
  { value: 'ZAR', label: 'ZAR — South African Rand' },
];

const EUROZONE = [
  'AT',
  'BE',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'ES',
  'HR',
];

const CURRENCY_COUNTRIES: Record<string, string[]> = {
  AUD: ['AU'],
  BRL: ['BR'],
  CAD: ['CA'],
  CHF: ['CH', 'LI'],
  CNY: ['CN'],
  CZK: ['CZ'],
  DKK: ['DK'],
  EUR: EUROZONE,
  GBP: ['GB'],
  HKD: ['HK'],
  HUF: ['HU'],
  ILS: ['IL'],
  INR: ['IN'],
  JPY: ['JP'],
  KRW: ['KR'],
  MXN: ['MX'],
  NOK: ['NO'],
  NZD: ['NZ'],
  PKR: ['PK'],
  PLN: ['PL'],
  SEK: ['SE'],
  SGD: ['SG'],
  THB: ['TH'],
  TRY: ['TR'],
  USD: ['US'],
  ZAR: ['ZA'],
};

export const countryCurrencyMap: Record<string, string> = Object.entries(
  CURRENCY_COUNTRIES
).reduce<Record<string, string>>((acc, [currency, countriesArr]) => {
  countriesArr.forEach((country) => {
    acc[country] = currency;
  });
  return acc;
}, {});

// Wise field keys that hold address fragments. Used to seed/clear from the
// "Use default billing address" affordance and to know which dynamic fields are
// address-shaped versus account-shaped.
export const ADDRESS_FIELD_KEYS = new Set([
  'address.country',
  'address.state',
  'address.city',
  'address.postCode',
  'address.firstLine',
]);
